import produce from 'immer';
import {
  SET_DETAIL_TABLE,
  LOADER_STATUS,
  SET_FILE_DATA,
  SET_OTP_BOX,
  OTP_INVALID,
  SET_FILE_ERROR,
  CHANGE_USERNAME,
  ON_CALL_UPLOAD,
  ON_SUBMIT_TRUE,
  SET_ERR_COUNT,
  SET_PROCESS_COUNT,
  PROFILE_INFO,
  SET_TABLE_DATA,
  TOTAL_RECORD,
  ON_NOTIFY
} from './constants';


export const initialState = {
    loaderStatus: false,
    profileData: [],
    fileData: [],
    isOtpActive: false,
    isOtpInvalid: false,
    processVal: '',
    errorVal:'',
    submitStatus:'',
    username:'',
    tableData:[],
    totalRecords: '',
    records: '',
    status: false,
    msg: '',
  };


  const uploadGstr9Reducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
        case ON_NOTIFY:
          return {
            ...state,
            status:action.status,
            msg:action.msg
          }
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
      case ON_SUBMIT_TRUE:
        return {
          ...state,
          submitStatus:action.submitStatus
        }
      case SET_ERR_COUNT:
        return {
          ...state,
          errorVal:action.errorVal
        }
      case SET_PROCESS_COUNT:
        return {
          ...state,
          processVal:action.processVal
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case SET_OTP_BOX:
        return {
          ...state,
          isOtpActive:action.isOtpActive
        }
      case OTP_INVALID:
        return {
          ...state,
          isOtpInvalid:action.isOtpInvalid
        }
      case SET_TABLE_DATA:
        return {
          ...state,
          tableData:action.tableData
        }
        case TOTAL_RECORD:
          return {
            ...state,
            totalRecords:action.totalRecords,
            records:action.records
          }
      default:
        return state;
    }
  };

export default uploadGstr9Reducer;